import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Seo } from "@/components/site/Seo";

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="mx-auto w-full max-w-6xl px-4 py-24 sm:px-6 lg:px-8">
      <Seo
        title="Page not found (404)"
        description="The page you requested doesn't exist. Return to the homepage or reach out via Contact for direct assistance."
        path="/404"
        noindex
      />
      <div className="mx-auto max-w-xl text-center">
        <div className="text-xs font-bold tracking-[0.2em] text-blue-700">404</div>
        <h1 className="mt-3 text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">Page not found</h1>
        <p className="mt-3 text-base text-slate-600">
          The page you requested doesn't exist. Try the homepage or contact us for direct assistance.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/">
            <Button className="h-11 rounded-lg bg-blue-600 px-5 text-white hover:bg-blue-700">Back to home</Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="h-11 rounded-lg border-slate-300 bg-white px-5 text-slate-900 hover:bg-slate-50">
              Contact us
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
